module.exports = __webpack_public_path__ + "img/decreto.e6ac57e8.jpg";